export enum SystemMessageTypesEnum {
	NewChat = '59af686a-d64c-46e4-afe7-91cf5ca81313',
	NewChatName = 'd9e2879e-5965-4d71-8e7b-0e757cf7081b',
	NewGroupChatMember = 'a67b54cd-8e7b-5965-4d71-7cf7081b0e75',
}


